import { api, apiRequest } from "./api";
import type {
  MaintenanceWindow,
  MaintenanceWindowFilters,
  MaintenanceWindowPaginatedResponse,
  MaintenanceWindowPayload,
} from "@/types/maintenance-windows";

const buildParams = (filters: MaintenanceWindowFilters = {}) => {
  const params: Record<string, string | number | boolean> = {
    page: filters.page ?? 1,
    page_size: filters.page_size ?? 20,
  };

  if (filters.is_active !== undefined) params.is_active = filters.is_active;
  if (filters.status && filters.status !== "all")
    params.status = filters.status;
  if (filters.date_from) params.date_from = filters.date_from;
  if (filters.date_to) params.date_to = filters.date_to;

  return params;
};

export async function fetchMaintenanceWindows(
  filters: MaintenanceWindowFilters = {}
): Promise<MaintenanceWindowPaginatedResponse> {
  return apiRequest(() =>
    api.get<MaintenanceWindowPaginatedResponse>(
      "/internal/core/maintenance-windows/",
      { params: buildParams(filters) }
    )
  );
}

export async function fetchMaintenanceWindowDetail(
  windowId: number
): Promise<MaintenanceWindow> {
  return apiRequest(() =>
    api.get<MaintenanceWindow>(
      `/internal/core/maintenance-windows/${windowId}/`
    )
  );
}

export async function createMaintenanceWindow(
  payload: MaintenanceWindowPayload
): Promise<MaintenanceWindow> {
  return apiRequest(() =>
    api.post<MaintenanceWindow>("/internal/core/maintenance-windows/", payload)
  );
}

export async function updateMaintenanceWindow(
  windowId: number,
  payload: MaintenanceWindowPayload
): Promise<MaintenanceWindow> {
  return apiRequest(() =>
    api.patch<MaintenanceWindow>(
      `/internal/core/maintenance-windows/${windowId}/`,
      payload
    )
  );
}

export async function disableMaintenanceWindow(
  windowId: number
): Promise<void> {
  await apiRequest(() =>
    api.delete(`/internal/core/maintenance-windows/${windowId}/`)
  );
}
